<template>
  <!-- 实时状态 -->
  <div class="timestatus">
    <el-form class="bginput" label-width="6rem">
      <el-form-item label="组态地址">
        <el-input v-model="formData.confUrl" placeholder="请录入组态页面地址"></el-input>
      </el-form-item>
    </el-form>
    <div style="margin-top: 2rem;">
      <el-button @click="save" size="small" type="primary">保存设置</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/apis/produce/timestatus'
export default {
  data() {
    return {
      formData: {
        confUrl: '',
      },
    }
  },
  mounted() {
    api
      .list({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            this.formData = res.data.list[0]
          }
        } else {
          this.$message.error(res.message)
        }
      })
  },
  methods: {
    save() {

      api.save(this.formData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.timestatus {
  width: 60%;
}
</style>